import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { authApi } from "@/lib/api";
import { useAuth } from "@/stores/auth";
import { FullPageSpinner } from "@/components/ui/spinner";

export default function Handoff() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const setSession = useAuth((s) => s.setSession);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get("token");
    if (!token) {
      toast.error("Sign-in link is invalid");
      navigate("/auth/login", { replace: true });
      return;
    }

    authApi
      .handoff(token)
      .then((session) => {
        setSession(session);
        navigate("/app/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in link has expired — please try again");
        navigate("/auth/login", { replace: true });
      });
  }, [searchParams, navigate, setSession]);

  return <FullPageSpinner label="Finishing sign-in…" />;
}
